import React from "react";
import { useNavigate } from "react-router-dom";
export default function Home() {

    const navigate = useNavigate();

  return (
    <div className="w-full font-sans">

      {/* Main section */}
      <section className="min-h-screen bg-gradient-to-br from-gray-900 via-black to-gray-800 flex items-center p-5">
        <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-2 gap-10 items-center">
          
          <div className="text-white">
            <h1 className="text-5xl md:text-6xl font-extrabold leading-tight">
              Style That <br /> Defines You
            </h1>
            <p className="mt-6 text-gray-300 text-lg">
              Minimal. Modern. Premium fashion experience.
            </p>
            <div className="mt-8 flex gap-4">
              <button onClick={() => navigate("/men")} className="px-8 py-3 bg-white text-black rounded-full font-semibold hover:scale-105 transition">
                Men
              </button>
              <button  onClick={()=>navigate('/women')} className="px-8 py-3 border border-white rounded-full hover:bg-white hover:text-black transition">
Women              </button>
            </div>
          </div>

          <div className="relative">
            <img
              src="https://images.unsplash.com/photo-1520975916090-3105956dac38"
              alt="hero"
              className="rounded-2xl shadow-2xl"
            />
          </div>

        </div>
      </section>

      {/* other information */}
      <section className="bg-white py-12">
        <div className="max-w-7xl mx-auto px-6 grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
          <div>
            <h3 className="text-xl font-bold">Premium Quality</h3>
            <p className="text-gray-500 mt-2">
              Crafted with attention to detail
            </p>
          </div>
          <div>
            <h3 className="text-xl font-bold">Modern Design</h3>
            <p className="text-gray-500 mt-2">
              Inspired by global trends
            </p>
          </div>
          <div>
            <h3 className="text-xl font-bold">Trusted Experience</h3>
            <p className="text-gray-500 mt-2">
              Loved by thousands of users
            </p>
          </div>
        </div>
      </section>

      {/* image */}
      <section className="bg-gray-100 py-16">
        <div className="max-w-7xl mx-auto px-6">
          <h2 className="text-3xl font-bold text-center mb-12">
            Our Collection Vibe
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <img
              className="rounded-xl hover:scale-105 transition"
              src="https://images.unsplash.com/photo-1503342217505-b0a15ec3261c"
              alt=""
            />
            <img
              className="rounded-xl hover:scale-105 transition"
              src="https://images.unsplash.com/photo-1512436991641-6745cdb1723f"
              alt=""
            />
            <img
              className="rounded-xl hover:scale-105 transition"
              src="https://images.unsplash.com/photo-1483985988355-763728e1935b"
              alt=""
            />
          </div>
        </div>
      </section>

      
      <section className="bg-black text-white py-20 text-center">
        <h2 className="text-4xl font-bold">Upgrade Your Look</h2>
        <p className="text-gray-400 mt-4">
          Simple. Stylish. Confident.
        </p>
        <button className="mt-8 px-10 py-4 bg-white text-black rounded-full font-semibold hover:scale-105 transition">
          Get Started
        </button>
      </section>

    </div>
  );
}